"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { scrollToMarketingSection } from "./marketingNav";

export function MarketingHashScroll() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname !== "/") {
      return;
    }

    const sectionId = window.location.hash.replace(/^#/, "");
    if (!sectionId) {
      return;
    }

    const scrollToHash = () => {
      if (!scrollToMarketingSection(sectionId)) {
        return false;
      }
      return true;
    };

    if (scrollToHash()) {
      return;
    }

    const retryTimer = window.setTimeout(() => {
      scrollToHash();
    }, 250);

    return () => {
      window.clearTimeout(retryTimer);
    };
  }, [pathname]);

  return null;
}
